export default {"src":"/_next/static/media/sticks.5bf4bfd8.gif","height":192,"width":256,"blurWidth":0,"blurHeight":0};